import { TextField } from '@mui/material';
import React, { forwardRef } from 'react';
import __t from '../../lib/traduzioni';
import { Controller } from 'react-hook-form';
import useBSSController from '../../hooks/useBSSController';
import useBSSLogger from '../../hooks/useBSSLogger';
import {IMaskInput} from 'react-imask';

const {logger} = useBSSLogger();

const TextMaskCustom = forwardRef((props, ref) => {

    const {name, onChange, ...other} = props;

    logger.debug("props a TextMaskCustom", name, other)

    return (
        <IMaskInput 
            {...other}            
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: name, value } })}
            overwrite
        />        
    )

})

const BSSText = ({
    name, 
    label = name,
    methods,
    dependsOn = null,
    ControllerProps = {},
    TextFieldProps = {},
    TextFieldInputProps = {},
    TextFieldinputProps = {},
    mask=null, // non utilizzare al momento non va
    definitions={},
}) => {
    
    const {classes, control, dipendenze, disabilitaByDep, defaultValue} = useBSSController({name, defaultValue: "", dependsOn, methods})

    
    let maskProps = {};
    if(mask !== null && false){
        maskProps = {inputComponent: forwardRef((props, ref) => <TextMaskCustom {...{...props, mask, definitions, ref}} />)}
    }

    return (
        <>
            <Controller
                name={name} 
                control={control}     
                defaultValue={defaultValue}                                           
                render={({field, fieldState}) => (
                    <>  
                        <TextField 
                            error={fieldState?.invalid ?? false}
                            disabled={disabilitaByDep}
                            variant="outlined" 
                            size="small"                             
                            fullWidth 
                            label={__t(label)}
                            {...field}
                            value={field.value}                            
                            inputRef={field.ref}
                            helperText={fieldState?.error?.message ?? undefined}
                            inputProps={{
                                classes: {root: classes.hasRightGroup},
                                autoComplete: 'new-password',
                                onFocus: e => (typeof e.target.select === 'function') &&  e.target.select(),
                                ...maskProps,
                                ...TextFieldinputProps
                            }}
                            InputProps={{                                                                
                                ...TextFieldInputProps
                            }}                            
                            {...TextFieldProps}
                        />
                    </>
                )}
                {...ControllerProps}        
            />            
        </>
    )
}

export default BSSText; 